// Contas com itens ocultos no menu lateral (sidebar).
// name: identificador do item em Sidebar.vue (menu principal ou filho de Settings/Campaigns).

export const SIDEBAR_HIDDEN_TOP_LEVEL_BY_ACCOUNT = {
  12: ['Reports', 'Portals'],
};

export const SIDEBAR_HIDDEN_SETTINGS_BY_ACCOUNT = {
  12: ['Conversation Workflow'],
};

// Filhos do menu Campaigns (Sidebar.vue: "Live chat", "SMS", "WhatsApp").
// Alumax (18): só campanhas WhatsApp (templates API oficial).
export const SIDEBAR_HIDDEN_CAMPAIGNS_BY_ACCOUNT = {
  18: ['Live chat', 'SMS'],
};

// Troca só o rótulo do menu; a rota continua sendo Teams (sem quebrar deep links).
export const SIDEBAR_LABEL_OVERRIDES_BY_ACCOUNT = {
  12: {
    'Settings Teams': 'Departamentos',
  },
};

export function hiddenSidebarTopLevel(accountId) {
  return new Set(SIDEBAR_HIDDEN_TOP_LEVEL_BY_ACCOUNT[Number(accountId)] || []);
}

export function hiddenSidebarSettings(accountId) {
  return new Set(SIDEBAR_HIDDEN_SETTINGS_BY_ACCOUNT[Number(accountId)] || []);
}

export function hiddenSidebarCampaigns(accountId) {
  return new Set(SIDEBAR_HIDDEN_CAMPAIGNS_BY_ACCOUNT[Number(accountId)] || []);
}

export function sidebarLabelOverride(accountId, itemName, fallbackLabel) {
  const map = SIDEBAR_LABEL_OVERRIDES_BY_ACCOUNT[Number(accountId)] || {};
  return map[itemName] || fallbackLabel;
}

export function filterSidebarMenuItems(items, accountId) {
  const hiddenTop = hiddenSidebarTopLevel(accountId);
  const hiddenSettings = hiddenSidebarSettings(accountId);
  const hiddenCampaigns = hiddenSidebarCampaigns(accountId);

  return items
    .filter(item => !hiddenTop.has(item.name))
    .map(item => {
      if (item.name === 'Settings' && item.children?.length) {
        return {
          ...item,
          children: item.children
            .filter(child => !hiddenSettings.has(child.name))
            .map(child => ({
              ...child,
              label: sidebarLabelOverride(accountId, child.name, child.label),
            })),
        };
      }

      if (item.name === 'Campaigns' && item.children?.length) {
        return {
          ...item,
          children: item.children.filter(
            child => !hiddenCampaigns.has(child.name)
          ),
        };
      }

      return item;
    });
}
